// @flow
// $FlowFixMe
import React, { useState, useEffect, useCallback } from 'react';
import classnames from 'classnames';
import { defineMessages, injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';

import styles from './FloatingScrollButton.css';
import IconLabel from '../util/IconLabel';
import { getScrollableSelector } from '../../utils/scroll';
import CapacitorRipple from '../capacitor/Ripple';

const messages = defineMessages({
  scrollToTop: {
    id: 'floating-scroll-button.scroll-to-top',
    defaultMessage: 'Scroll to top',
  },
  scrollToBottom: {
    id: 'floating-scroll-button.scroll-to-bottom',
    defaultMessage: 'Scroll to bottom',
  },
});

type OwnProps = {
  target: string,
};

type Props = OwnProps & { intl: IntlShape };

const FloatingScrollButton = ({ target, intl }: Props) => {
  const [atTarget, setAtTarget] = useState(false);

  useEffect(() => {
    const targetEl = document.getElementById(target);
    if (!targetEl) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setAtTarget(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    observer.observe(targetEl);
    return () => observer.disconnect();
  }, [target]);

  const onClick = useCallback(() => {
    if (atTarget) {
      const scrollableEl = getScrollableSelector();
      if (scrollableEl) {
        scrollableEl.scrollTo({ top: 0, behavior: 'smooth' });
      }
    } else {
      const targetEl = document.getElementById(target);
      if (targetEl) {
        targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [atTarget, target]);

  return (
    <button
      className={classnames(styles.button)}
      onClick={onClick}
      aria-label={
        atTarget
          ? intl.formatMessage(messages.scrollToTop)
          : intl.formatMessage(messages.scrollToBottom)
      }
    >
      <CapacitorRipple />
      <IconLabel name={atTarget ? 'chevron-up' : 'chevron-down'} size="default" />
    </button>
  );
};

export default injectIntl(FloatingScrollButton);
